import React from 'react'
import PropTypes from 'prop-types'

const Divider = (props, context) => {
  const { inset, theme, ...other } = props

  return <hr {...other} className={theme['divider']} />
}

Divider.propTypes = {
  /**
   * If true, the `Divider` will be indented.
   */
  inset: PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: PropTypes.object,
}

Divider.defaultProps = {
  inset: false,
}

Divider.contextTypes = {
  theme: PropTypes.object.isRequired,
}

export default Divider



// WEBPACK FOOTER //
// ./ui/Element/Divider.js